import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=586747be&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=ts&"
export * from "./Sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=586747be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586747be",
  null
  
)

export default component.exports